<template>
    <modal :id="id" :loading="loading" :saveing="saveing" @shown="shown" @ok="save" @cancel="cancel">
        <span slot="modal-title">學生基本資料</span>
        <div role="tablist">
            <b-button class="mb-1" block v-b-toggle.accordion-1>基本資料</b-button>
            <b-collapse id="accordion-1" visible accordion="my-accordion" role="tabpanel">
                <div class="row">
                    <div class="col-md-4 col-sm-12">
                        <div class="row">
                            <div class="col-12">
                                <img v-if="vm.File" :src="imgSrc" style="max-width:100%" />
                            </div>
                            <div class="col-12">
                                <file-upload :url="'/api/file/Studata/File?id='+modalkey" @ok="ok"></file-upload>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-8">
                        <div class="row">
                            <div class="col-12">
                                <form-input v-model="vm.StudentNo" id="StudentNo" label="學號" type="text" :disabled="isedit" required></form-input>
                            </div>
                            <div class="col-md-6 col-sm-12">
                                <form-input v-model="vm.Name" id="Name" label="中文姓名" type="text" required></form-input>
                            </div>
                            <div class="col-md-6 col-sm-12">
                                <form-input v-model="vm.Nickname" id="Nickname" label="暱稱" type="text" required></form-input>
                            </div>

                            <div class="col-md-6 col-sm-12">
                                <form-select v-model="vm.Sex" id="Sex" label="性別" required>
                                    <div is="option" value="M">男</div>
                                    <div is="option" value="F">女</div>
                                </form-select>
                            </div>
                            <div class="col-md-6 col-sm-12">
                                <form-date-input v-model="vm.Birthday" id="Birthday" label="出生日期" required></form-date-input>
                            </div>
                            <div class="col-md-6 col-sm-12">
                                <form-input v-model="vm.SchoolEMail" id="SchoolEMail" label="校E-Mail" type="email" required></form-input>
                            </div>
                            <div class="col-md-6 col-sm-12">
                                <form-input v-model="vm.CodeNm" id="CodeNm" label="身分別" type="text" disabled></form-input>
                            </div>
                            <div class="col-12">
                                <form-input v-model="vm.StudentEMail" id="StudentEMail" label="常用E-Mail" type="email" required></form-input>
                            </div>
                            <div class="col-md-6 col-sm-12">
                                <form-input v-model="vm.Phone" id="Phone" label="手機" type="tel" required></form-input>
                            </div>
                            <div class="col-md-6 col-sm-12">
                                <form-input v-model="vm.HomePhone" id="HomePhone" label="家裡電話" type="tel" required></form-input>
                            </div>
                            <div class="col-12">
                                <form-input v-model="vm.Address" id="Address" label="通訊地址" type="text" required></form-input>
                            </div>
                            <div class="col-md-6 col-sm-12">
                                <form-input v-model="vm.Height" id="Height" label="身高" type="number" required></form-input>
                            </div>
                            <div class="col-md-6 col-sm-12">
                                <form-input v-model="vm.Weight" id="Weight" label="體重" type="number" required></form-input>
                            </div>
                            <div class="col-12">
                                <form-input v-model="vm.SpecialDisease" id="SpecialDisease" label="特殊疾病" type="text" required></form-input>
                            </div>
                            <div class="col-md-6 col-sm-12">
                                <form-input v-model="vm.EnFirstName" id="EnFirstName" label="英文姓" type="text"></form-input>
                            </div>
                            <div class="col-md-6 col-sm-12">
                                <form-input v-model="vm.EnLastName" id="EnLastName" label="英文名" type="text"></form-input>
                            </div>
                            <div class="col-12">
                                <form-input v-model="vm.PassportNo" id="PassportNo" label="護照號碼" type="text"></form-input>
                            </div>
                        </div>
                    </div>
                </div>
            </b-collapse>

            <b-button class="mb-1" block v-b-toggle.accordion-2>父親</b-button>
            <b-collapse id="accordion-2" accordion="my-accordion" role="tabpanel">
                <div class="row">
                    <div class="col-12">
                        <form-input v-model="vm.FName" id="FName" label="姓名" type="text" required></form-input>
                    </div>
                    <div class="col-12">
                        <form-input v-model="vm.FJob" id="FJob" label="職業" type="text" required></form-input>
                    </div>
                    <div class="col-12">
                        <form-input v-model="vm.FPhone" id="FPhone" label="聯絡電話" type="tel" required></form-input>
                    </div>
                    <!--<div class="col-12">
                        <form-input v-model="vm.FEMail" id="FEMail" label="EMail" type="email" required></form-input>
                    </div>-->
                </div>
            </b-collapse>

            <b-button class="mb-1" block v-b-toggle.accordion-3>母親</b-button>
            <b-collapse id="accordion-3" accordion="my-accordion" role="tabpanel">
                <div class="row">
                    <div class="col-12">
                        <form-input v-model="vm.MName" id="MName" label="姓名" type="text" required></form-input>
                    </div>
                    <div class="col-12">
                        <form-input v-model="vm.MJob" id="MJob" label="職業" type="text" required></form-input>
                    </div>
                    <div class="col-12">
                        <form-input v-model="vm.MPhone" id="MPhone" label="聯絡電話" type="tel" required></form-input>
                    </div>
                    <!--<div class="col-12">
                        <form-input v-model="vm.MEMail" id="MEMail" label="EMail" type="email" required></form-input>
                    </div>-->
                </div>
            </b-collapse>

            <b-button class="mb-1" block v-b-toggle.accordion-4>校內/校外聯絡人</b-button>
            <b-collapse id="accordion-4" accordion="my-accordion" role="tabpanel">
                <div class="row">
                    <div class="col-12">
                        校內
                    </div>
                    <div class="col-12">
                        <form-input v-model="vm.InName" id="InName" label="姓名" type="text" required></form-input>
                    </div>
                    <div class="col-12">
                        <form-input v-model="vm.InRelationship" id="InRelationship" label="關係" type="text" required></form-input>
                    </div>
                    <div class="col-12">
                        <form-input v-model="vm.InTel" id="InTel" label="電話" type="tel" required></form-input>
                    </div>
                    <div class="col-12">
                        校外
                    </div>
                    <div class="col-12">
                        <form-input v-model="vm.OutName" id="OutName" label="姓名" type="text" required></form-input>
                    </div>
                    <div class="col-12">
                        <form-input v-model="vm.OutRelationship" id="OutRelationship" label="關係" type="text" required></form-input>
                    </div>
                    <div class="col-12">
                        <form-input v-model="vm.OutTel" id="OutTel" label="電話" type="tel" required></form-input>
                    </div>
                </div>
            </b-collapse>

            <b-button class="mb-1" block v-b-toggle.accordion-5>自傳</b-button>
            <b-collapse id="accordion-5" accordion="my-accordion" role="tabpanel">
                <form-textarea v-model="vm.Autobiography" id="Autobiography"></form-textarea>
            </b-collapse>

            <b-button class="mb-1" block v-b-toggle.accordion-6 @click="show6">缺曠</b-button>
            <b-collapse id="accordion-6" accordion="my-accordion" role="tabpanel">
                <div class="col-12">
                    <table class="table">
                        <thead>
                            <tr>
                                <th>學年度-學期</th>
                                <th>曠缺名稱</th>
                                <th>曠缺日期</th>
                                <th>曠缺節次起-迄</th>
                            </tr>
                        </thead>
                        <tr v-for="item in table6Data">
                            <td>{{item.ACADMYEAR}}-{{item.TERM}}</td>
                            <td>{{item.COMT}}</td>
                            <td>{{item.DAT}}</td>
                            <td>{{item.FRNO}}-{{item.TONO}}</td>
                        </tr>
                    </table>
                </div>
            </b-collapse>

            <b-button class="mb-1" block v-b-toggle.accordion-7 @click="show7">獎懲</b-button>
            <b-collapse id="accordion-7" accordion="my-accordion" role="tabpanel">
                <div class="col-12">
                    <table class="table">
                        <thead>
                            <tr>
                                <th>學年度-學期</th>
                                <th>獎懲類別</th>
                                <th>獎懲日期</th>
                                <th>獎懲次數</th>
                                <th>獎懲內容</th>
                            </tr>
                        </thead>
                        <tr v-for="item in table7Data">
                            <td>{{item.ACADMYEAR}}-{{item.TERM}}</td>
                            <td>{{item.KD2}}</td>
                            <td>{{item.DAT}}</td>
                            <td>{{item.QTY2}}</td>
                            <td>{{item.COMT}}</td>
                        </tr>
                    </table>
                </div>
            </b-collapse>
        </div>
    </modal>
</template>

<script>
    import { detail } from '@/views';
    export default detail({
        name: 'studataDetail',
        api: '/api/studata/',
        data: { table6Data: [], table7Data: [] },
        computed: {
            imgSrc: function () {
                return this.$apiurl + 'upload/stu/' + this.modalkey + "/" + this.vm.File;
            },
        },
        methods: {
            show6: function () {
                return this.$http({ method: 'get', url: 'api/Attendance/Get?No=' + this.vm.StudentNo })
                    .then(res => {
                        this.table6Data = res.data;
                    });
            },
            show7: function () {
                return this.$http({ method: 'get', url: 'api/RewardsPunishments/Get?No=' + this.vm.StudentNo })
                    .then(res => {
                        this.table7Data = res.data;
                    });
            },
            ok: function (e) {
                this.vm.File = e.res.data + "?t=" + new Date();
            },
            save: function () {
            }
        }
    });
</script>

<style>
</style>